/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
// import config from "../config/getTokenDetails.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_TOKEN_DETAILS } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import moment from "moment";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetTokenDetailsMethods extends IPluginMethodMap {
  getTokenDetails(args: any): Promise<any>;
}

export class GetTokenDetailsService implements IAgentPlugin {
  readonly methods: IGetTokenDetailsMethods;

  constructor() {
    this.methods = {
      getTokenDetails: this.getTokenDetails.bind(this),
    };
  }

  async getTokenDetails(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    //return {...(config)}
    const distCenterData = storageService.get("distCenterData", "local");
    console.log(`bla distCenterData in payment service`, distCenterData);
    try {
      if (client) {
        const res = await client.query({
          query: GET_TOKEN_DETAILS,
          variables: {
            filter: {
              tokenKey: args?.tokenKey,
            },
          },
          fetchPolicy: "newtwork-only",
        });
        if (res?.data) {
          console.log(`payment queue data`, res.data);
          return {
            list: this.formatData(res?.data?.getToken),
            isGroup: res?.data?.getToken?.isGroup,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {...(config || {})}
  }

  private formatData(data: any) {
    let _formattedData: any = [];
    if (data?.isGroup) {
      let _groupData: any = [];
      data?.boxes?.forEach((_box: any) => {
        let _boxData: any = [];
        if (_box?.masqID) {
          _boxData.push({
            label: "Masquerader ID",
            value: _box?.masqID,
          });
        }
        if (_box?.costumeID) {
          _boxData.push({
            label: "Costume ID",
            value: _box?.costumeID,
          });
        }
        if (data?.isVipToken.toString() === "true") {
          _boxData.push({
            label: "VIP",
            value: "Yes",
          });
        } else {
          _boxData.push({
            label: "VIP",
            value: "No",
          });
        }
        if (_box?.section) {
          _boxData.push({
            label: "Section",
            value: _box?.section,
          });
        }
        if (_box?.sectionOptType) {
          _boxData.push({
            label: "Section Opt Types",
            value: _box?.sectionOptType,
          });
        }
        if (_box?.user?.fullName) {
          _boxData.push({
            label: "Name",
            value: _box?.user?.fullName,
          });
        }
        if (_box?.user?.email) {
          _boxData.push({
            label: "Email",
            value: _box?.user?.email,
          });
        }
        if (
          _box?.user?.primaryContactNo ||
          (_box?.user?.phoneNumbers && _box?.user?.phoneNumbers?.length > 0)
        ) {
          _boxData.push({
            label: "Phone Number",
            value:
              _box?.user?.primaryContactNo ??
              (_box?.user?.phoneNumbers && _box?.user?.phoneNumbers?.length > 0)
                ? _box?.user?.phoneNumbers[0]?.number
                : "",
          });
        }
        if (_box?.collectorProfile?.name) {
          _boxData.push({
            label: "Delegrate Name",
            value: _box?.collectorProfile?.collectorType,
          });
        }
        if (_box?.comments) {
          _boxData.push({
            label: "Comments",
            value: _box?.comments,
          });
        }
        _groupData.push(_boxData);
      });
      return _groupData;
    } else {
      const _box =
        data?.boxes && Array.isArray(data?.boxes) && data?.boxes.length > 0
          ? data?.boxes[0]
          : {};
      if (_box?.masqID) {
        _formattedData.push({
          label: "Masquerader ID",
          value: _box?.masqID,
        });
      }
      if (_box?.costumeID) {
        _formattedData.push({
          label: "Costume ID",
          value: _box?.costumeID,
        });
      }
      if (data?.isVipToken.toString() === "true") {
        _formattedData.push({
          label: "VIP",
          value: "Yes",
        });
      } else {
        _formattedData.push({
          label: "VIP",
          value: "No",
        });
      }
      if (_box?.section) {
        _formattedData.push({
          label: "Section",
          value: _box?.section,
        });
      }
      if (_box?.sectionOptType) {
        _formattedData.push({
          label: "Section Opt Types",
          value: _box?.sectionOptType,
        });
      }
      if (_box?.user?.fullName) {
        _formattedData.push({
          label: "Name",
          value: _box?.user?.fullName,
        });
      }
      if (_box?.user?.email) {
        _formattedData.push({
          label: "Email",
          value: _box?.user?.email,
        });
      }
      if (
        _box?.user?.primaryContactNo ||
        (_box?.user?.phoneNumbers && _box?.user?.phoneNumbers?.length > 0)
      ) {
        _formattedData.push({
          label: "Phone Number",
          value:
            _box?.user?.primaryContactNo ??
            (_box?.user?.phoneNumbers && _box?.user?.phoneNumbers?.length > 0)
              ? _box?.user?.phoneNumbers[0]?.number
              : "",
        });
      }
      if (_box?.collectorProfile?.name) {
        _formattedData.push({
          label: "Delegrate Name",
          value: _box?.collectorProfile?.collectorType,
        });
      }
      if (_box?.comments) {
        _formattedData.push({
          label: "Comments",
          value: _box?.comments,
        });
      }
    }

    return _formattedData;
  }
}
